
function updateJudgeMeAvgText(root = document) {
  root.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
    const avg = parseFloat(badge.getAttribute('data-average-rating'));
    if (!Number.isFinite(avg)) return;

    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;


    const formatted =
      Number.isInteger(avg) ? avg.toString() : avg.toFixed(2);

    const newText = `(${formatted})`;

    if (textEl.textContent.trim() !== newText) {
      //console.log("Changing ", textEl.textContent, "to ", newText)
      textEl.textContent = newText;
    }
  });
}


function observeBadgesInRecommendations() {
  const section = document.querySelector('section[id*="__related-products"] product-recommendations');
  if (!section) return

  // console.log('[init] badges in recommendations:', sec.querySelectorAll('.jdgm-prev-badge').length);
  updateJudgeMeAvgText(section);

  const mo = new MutationObserver(() => {
    //const badges = section.querySelectorAll('.jdgm-prev-badge');
    // console.log('[updated] badges in recommendations:', badges.length, badges);
    updateJudgeMeAvgText(section);

  });
  mo.observe(section, { childList: true, subtree: true });
}

window.addEventListener('load', observeBadgesInRecommendations);
